// extracted by mini-css-extract-plugin
module.exports = {"component":"loading-indicator-component--2Ikie"};